import { c as _c } from "react/compiler-runtime";
import { ErrorMessage, RadioCard } from "@justhome/react-ui";
import { ProjectDecision } from "@modules/booking/context/machine";
import { useQualificationContext } from "@modules/booking/context/context";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import FormSection from "../FormSection";
import PropertyCard from "../PropertyCard";
interface ProjectConfirmationFormValues {
  projectDecision: ProjectDecision;
}
const ProjectConfirmation = () => {
  const $ = _c(41);
  const {
    t
  } = useBookingTranslation();
  const {
    matchedProject,
    handleProjectDecision
  } = useQualificationContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    register,
    handleSubmit,
    formState: t1
  } = useForm(t0);
  const {
    errors
  } = t1;
  let t2;
  if ($[1] !== handleProjectDecision) {
    t2 = t3 => {
      const {
        projectDecision
      } = t3;
      handleProjectDecision(projectDecision);
    };
    $[1] = handleProjectDecision;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSubmit = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("projectConfirmation.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleSubmit || $[6] !== onSubmit) {
    t4 = handleSubmit(onSubmit);
    $[5] = handleSubmit;
    $[6] = onSubmit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== matchedProject) {
    t5 = matchedProject && <PropertyCard project={matchedProject} />;
    $[8] = matchedProject;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== register || $[11] !== t) {
    t6 = register("projectDecision", {
      required: t("projectConfirmation.decisionRequiredError")
    });
    $[10] = register;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("projectConfirmation.existingProject");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <RadioCard value="existing" type="radio" size="sm" {...t6}>{t7}</RadioCard>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== register || $[19] !== t) {
    t9 = register("projectDecision", {
      required: t("projectConfirmation.decisionRequiredError")
    });
    $[18] = register;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("projectConfirmation.newProject");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <RadioCard value="new" type="radio" size="sm" {...t9}>{t10}</RadioCard>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t8) {
    t12 = <div className="flex flex-col gap-3xs">{t8}{t11}</div>;
    $[26] = t11;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== errors.projectDecision) {
    t13 = errors.projectDecision && <ErrorMessage>{errors.projectDecision?.message}</ErrorMessage>;
    $[29] = errors.projectDecision;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <FormRow><FormField>{t12}{t13}</FormField></FormRow>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14 || $[35] !== t4 || $[36] !== t5) {
    t15 = <Form id="project-confirmation-form" onSubmit={t4}>{t5}{t14}</Form>;
    $[34] = t14;
    $[35] = t4;
    $[36] = t5;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15 || $[39] !== t3) {
    t16 = <FormSection title={t3} formId="project-confirmation-form" canGoBack={false}>{t15}</FormSection>;
    $[38] = t15;
    $[39] = t3;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
export default ProjectConfirmation;